<script>
export default {
  name: "ClientsScroll",
  props: {
    categories: Array,
    clients: Array
  },
  data() {
    return {
      currentCategory: null,
      categoriesScrolledLeft: false,
      categoriesScrolledRight: false,
    };
  },
  computed: {
    filteredClients() {
      return this.clients.filter((client) => {
        return this.currentCategory === null || client.category_id == this.currentCategory;
      });
    },
    groupedClients() {
      const perChunk = 3;
      return this.filteredClients.reduce((resultArray, item, index) => { 
        const chunkIndex = Math.floor(index / perChunk)

        if(!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = []
        }

        resultArray[chunkIndex].push(item)

        return resultArray
      }, []);
    },
    contentKey() {
      if (this.currentCategory === null) {
        return "category-all";
      }

      return "category-" + this.currentCategory;
    }
  },
  mounted() {
    const updateScroll = () => {
      const scroll = this.$refs.categoriesScroll.scrollLeft;
      const scrollWidth = this.$refs.categoriesScroll.scrollWidth;
      const offsetWidth = this.$refs.categoriesScroll.offsetWidth;

      this.categoriesScrolledLeft = scroll === 0;
      this.categoriesScrolledRight = scroll >= (scrollWidth - offsetWidth);
    }

    this.$refs.categoriesScroll.addEventListener('scroll', function(/*e*/) {
      updateScroll();
    });

    updateScroll();
  }
};
</script>

<template>
  <div class="scroll-wrap center-wrap" :class="{'show-left': !categoriesScrolledLeft, 'show-right': !categoriesScrolledRight}">
    <div class="scroll" ref="categoriesScroll">
      <div class="clients-categories">
        <button class="category" :class="{current: currentCategory === null}" @click="currentCategory = null">{{ $v("STR_ALL") }}</button>
        <button v-for="category in categories" :key="category.id" class="category" :class="{current: currentCategory == category.id}" @click="currentCategory = category.id">{{ category.title }}</button>
      </div>
    </div>
  </div>
  <clients-scroller :key="contentKey">
    <div class="spacer left-spacer swiper-slide"></div>
    <template v-for="(group, index) in groupedClients" :key="index">
      <div v-if="index % 2 == 0" class="client-group separator swiper-slide" :class="['colors-' + ((index / 2) % 3)]">
        <div class="item-wrap">
          <div class="item">{{index}}</div>
        </div>
        <div class="item-wrap">
          <div class="item"></div>
        </div>
        <div class="item-wrap">
          <div class="item"></div>
        </div>
      </div>
      <div class="client-group swiper-slide">
        <div v-for="item in group" class="item-wrap" :key="item.id">
          <a v-if="item.url" class="item" :href="item.url" :title="item.title" v-html="item.image || ''"></a>
          <div v-else class="item" :title="item.title" v-html="item.image || ''"></div>
        </div>
        <template v-if="group.length < 3">
          <div v-for="index2 in (3 - group.length)" class="item-wrap" :key="'color-' + index2">
            <div class="item color" :class="['color-' + (index + index2) % 3]"></div>
          </div>
        </template>
      </div>
    </template>
    <div class="client-group separator swiper-slide" :class="['colors-' + (Math.ceil(groupedClients.length / 2) % 3)]">
      <div class="item-wrap">
          <div class="item"></div>
      </div>
      <div class="item-wrap">
          <div class="item"></div>
      </div>
      <div class="item-wrap">
          <div class="item"></div>
      </div>
    </div>
    <div class="spacer right-spacer swiper-slide"></div>
  </clients-scroller>
</template>

<style lang="scss" scoped>
.scroll-wrap {
  position: relative;

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    height: 32px;
    width: 20px;
    background: linear-gradient(90deg, rgba(244,244,244,1) 0%, rgba(244,244,244,0) 100%);
    visibility: hidden;
    opacity: 0;
    transition: 0.3s;
  }

  &.show-left::before {
    visibility: visible;
    opacity: 1;
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    right: 0;
    top: 0;
    height: 32px;
    width: 20px;
    background: linear-gradient(270deg, rgba(244,244,244,1) 0%, rgba(244,244,244,0) 100%); 
    visibility: hidden;
    opacity: 0;
    transition: 0.3s;
  }

  &.show-right::after {
    visibility: visible;
    opacity: 1;
  }

  @media screen and (max-width: 1260px) {
    margin-left: $page-margin-desktop;
    margin-right: $page-margin-desktop;
    padding: 0;
    width: auto;
  }

  @media screen and (max-width: 1260px) {
    margin-left: $page-margin-mobile;
    margin-right: $page-margin-mobile;
    padding: 0;
    width: auto;
  }
}

.scroll {
  overflow: auto;

  /*
  overflow-x auto;
  overflow-y: hidden;
  */
}

.clients-categories {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 10px;

  .category {
    border: 1px solid $color-brand-1;
    background: transparent;
    color: $color-brand-1;
    font-size: 14px;
    padding: 0 15px 0 15px;
    height: 32px;
    border-radius: 16px;
    margin: 0 5px 10px 5px;
    cursor: pointer;
    transition: 0.3s;
    white-space: nowrap;

    &:first-child {
      margin-left: auto;
    }

    &:last-child {
      margin-right: auto;
    }

    &.current, &:hover {
      background: $color-brand-2;
      border-color: $color-brand-2;
      color: #fff;
    }
  }
}

.left-spacer {
  width: calc(max((100% - 1160px) / 2, 50px)) !important;

  @media screen and (max-width: 1000px) {
    width: 25px !important;
  }
}

.right-spacer {
  width: 90px;

  @media screen and (max-width: 1250px) {
    width: 140px;
  }

  @media screen and (max-width: 1000px) {
    width: 115px;
  }
}
</style>
